<div class="card col-sm-10" *ngIf="bookings.length > 0">
  <div *ngFor="let booking of bookings" class="row upcoming-booking">
    <div class="col-sm-8 row">
      <span class="col-sm-12 col-md-3 item-label"
        >{{ 'ACCOUNT.SERVICE' | translate }}:</span
      >
      <span class="col-sm-12 col-md-9 mb-1">{{ booking.service_name }}</span>

      <span class="col-sm-12 col-md-3 item-label"
        >{{ 'ACCOUNT.DATE' | translate }}:</span
      >
      <span class="col-sm-12 col-md-9 mb-1">{{
        booking.datetime.format('Do MMMM YYYY')
      }}</span>

      <span class="col-sm-12 col-md-3 item-label"
        >{{ 'ACCOUNT.TIME' | translate }}:</span
      >
      <span class="col-sm-12 col-md-9 mb-1">{{
        booking.datetime | date : 'HH:mm'
      }}</span>
    </div>
    <div class="col-sm-4 text-right details-row">
      <button
        class="btn btn-primary col-sm-12 col-md-12 col-lg-6"
        (click)="openModifyDialog(booking)"
      >
        {{ 'ACCOUNT.AMEND' | translate }}
      </button>
      <button
        class="btn btn-primary col-sm-12 col-md-12 col-lg-6"
        (click)="openCancelDialog(booking)"
      >
        {{ 'ACCOUNT.CANCEL' | translate }}
      </button>
      <button
        class="btn btn-primary col-sm-12 col-md-12 col-lg-6"
        (click)="openDetailsDialog(booking)"
      >
        {{ 'ACCOUNT.DETAILS' | translate }}
      </button>
    </div>
  </div>
</div>
<h2 class="no-bookings" *ngIf="bookings.length === 0">
  {{ 'ACCOUNT.NO_UPCOMING_BOOKINGS' | translate }}
</h2>
